import type {EmployeeProfile} from '../types';

interface Props {
  navigate: (page: 'knowledge-base' | 'crm' | 'ship' | 'find-anything' | 'log-return' | 'new-invoice' | 'support' | 'dashboard' | 'orders' | 'returns' | 'return-check-in' | 'giveaways' | 'dev-agent' | 'hiring' | 'assistant') => void;
  profile: EmployeeProfile;
  canCrm?: boolean;
}

export function HomePage({navigate, profile, canCrm = false}: Props) {
  return (
    <>
      <header className="page-header">
        <p className="eyebrow">Mentra operations</p>
        <h1>One front door for internal work.</h1>
        <p>Start with the job you need to do. The systems behind it can remain independently deployed.</p>
      </header>
      <section className="tool-grid">
        <ToolCard eyebrow="Company intelligence" title="Assistant" description="Ask about live operations, find useful links, and search company knowledge." action="Ask the assistant" onClick={() => navigate('assistant')} />
        {canCrm && <ToolCard eyebrow="Relationships" title="CRM" description="Customer conversations, relationship context, and next steps from company email." action="Open CRM" onClick={() => navigate('crm')} />}
        {profile.role !== 'employee' && <ToolCard eyebrow="Shipping" title="Ship" description="Review a FedEx quote, create labels, and arrange pickup." action="Ship a package" onClick={() => navigate('ship')} />}
        <ToolCard eyebrow="Knowledge" title="Knowledge Base" description="Correct what the support agent knows, edit answers, and review changes." action="Manage knowledge" onClick={() => navigate('knowledge-base')} />

        <ToolCard eyebrow="Customer experience" title="Customer Support" description="Find Zendesk tickets, review conversations, and focus on the customers who need a reply." action="Open support inbox" onClick={() => navigate('support')} />
        <ToolCard eyebrow="Sales" title="New invoice" description="Create an unsent Mentra Live invoice from structured details, text, or files." action="Create an invoice" onClick={() => navigate('new-invoice')} />
        <ToolCard eyebrow="Receiving" title="Check in a return" description="Scan the package, find the complaint and order, record the unit, and keep the physical finding separate from the customer's report." action="Start check-in" onClick={() => navigate('return-check-in')} />
        <ToolCard eyebrow="Company" title="Dashboard" description="Current operational summary plus a safe link to Kaden's unchanged KPI dashboard." action="View dashboard" onClick={() => navigate('dashboard')} />
        {profile.role !== 'employee' && <ToolCard eyebrow="Operations" title="Open orders" description="Follow every order through supplier handoff, fulfillment, carrier scans, SLA risk, and delivery." action="Open orders" onClick={() => navigate('orders')} />}
        {profile.role !== 'employee' && <ToolCard eyebrow="Operations" title="Giveaways" description="Create campaign windows and limits, review device registrations, and export campaign records." action="Manage giveaways" onClick={() => navigate('giveaways')} />}
      </section>
    </>
  );
}

function ToolCard({eyebrow, title, description, action, onClick}: {eyebrow: string; title: string; description: string; action: string; onClick: () => void}) {
  return (
    <article className="tool-card home-blue">
      <p className="eyebrow">{eyebrow}</p>
      <h2>{title}</h2>
      <p>{description}</p>
      <button className="secondary-button" onClick={onClick}>{action}</button>
    </article>
  );
}
